import AddressLookup from './AddressLookup.vue';

export default AddressLookup;
